import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, inject, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-help',
  imports: [
    CommonModule,
    MatIconModule,
    TranslateModule
  ],
  standalone: true,
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss']
})

export class HelpComponent implements OnInit, OnDestroy {
  // Services 
  private readonly translate: TranslateService = inject(TranslateService);
  private readonly cdr: ChangeDetectorRef = inject(ChangeDetectorRef);

  // Component API
  @Input() text: string = "";
  @Input() link!: string;
  @Input() size: string = '24px';
  @Input() width!: string;
  @Input() template!: TemplateRef<any>;
  @Input() images!: string[];
  @Input() help: boolean = false;
  @Input() minWidth!: string;

  @ViewChild('bubble', { static: false }) bubble!: ElementRef;
  @ViewChild('container', { static: false }) container!: ElementRef;
  @ViewChild('popOver', { static: false }) popOver!: ElementRef;

  // Variables
  isPopupVisible: boolean = false;
  isBorderRightDetected: boolean = false;
  isBorderLeftDetected: boolean = false;
  popOverLeft!: string;
  popWidth!: string;
  popMinWidth!: string;
  limiteBorder!: number;
  destroy$ = new Subject<void>();

  popupTop!: any;
  popupLeft!: number;

  constructor() { }

  ngOnInit() {
    if (!this.text || this.text === "") {
      this.translate.get("see_more").subscribe((res: string) => {
        this.text = res;
        this.cdr.markForCheck();
      });
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  togglePopup() {
    this.isPopupVisible = !this.isPopupVisible;
    this.cdr.detectChanges();

    if (this.isPopupVisible) {
      const popOverRect = this.popOver.nativeElement.getBoundingClientRect();
      const windowWidth2 = window.innerWidth;

      if (!this.width) {
        this.popWidth = "300px";
      } else {
        this.popWidth = parseFloat(this.width) + "px";
      }
      if (this.minWidth) this.popMinWidth = parseFloat(this.minWidth) + "px";


      this.verifBorders(popOverRect.right, popOverRect.left, windowWidth2);
    }
  }

  verifBorders(bubbleRight: number, bubbleLeft: number, windowWidth: number) {
    if (windowWidth - bubbleRight < 0) {
      const overtaking = bubbleRight - windowWidth + 50;
      this.popOverLeft = "-" + (overtaking + 15) + "px";
    } else if (bubbleLeft < 0) {
      const overtaking = bubbleLeft + 28;
      this.popOverLeft = overtaking + "px";
    }
  }

}